import { forwardRef } from "react"
import { useTranslation } from "react-i18next"
import { match } from "ts-pattern"
import { Badge, BadgeProps } from "@mantine/core"
import { WorkflowResult } from "../../@client/Absents"

interface Props extends BadgeProps {
  status: WorkflowResult
}

export const AbsentApprovalStatusBadge = forwardRef<HTMLDivElement, Props>(
  ({ status, ...props }, ref) => {
    const { t } = useTranslation("app_server")

    const statusProps: BadgeProps = match(status)
      .with({ Case: "Approved" }, () => ({
        color: "green",
        children: t("Approved"),
      }))
      .with({ Case: "Rejected" }, () => ({
        color: "red",
        children: t("Rejected"),
      }))
      .with({ Case: "Pending" }, () => ({
        color: "blue",
        children: t("Pending"),
      }))
      .with({ Case: "Canceled" }, () => ({
        color: "gray",
        children: t("Canceled"),
      }))
      .exhaustive()

    return <Badge ref={ref} {...statusProps} {...props} />
  }
)

AbsentApprovalStatusBadge.displayName = "AbsentApprovalStatusBadge"
